import { render, staticRenderFns } from "./vfg-vsselect.vue?vue&type=template&id=01343903"
import script from "./vfg-vsselect.vue?vue&type=script&lang=js"
export * from "./vfg-vsselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports